document.addEventListener('DOMContentLoaded', () => {
  filterProgramWidget();
});

function filterProgramWidget() {
  document.querySelectorAll('.js-filter-program-widget').forEach((element) => {
    const button = element.querySelector('.filter-program-widget__button');
    const gradeSelect = element.querySelector('#select_grade');
    const typeSelect = element.querySelector('#select_type');
    const items = element.querySelectorAll('.page-preview');

    if (!button) return;

    button.addEventListener('click', (e) => {
      e.preventDefault();
      if (!items.length) return;

      const grade = gradeSelect ? gradeSelect.value : '';
      const type = typeSelect ? typeSelect.value : '';

      filterByParams(grade, type, items);
    });

    const { grade, type } = getFiltersFromUrl();
    filterByParams(grade, type, items);
    updateSelectsValues(grade, type, gradeSelect, typeSelect);
  });
}

function filterByParams(grade = null, type = null, items = []) {
  if (!items.length) return;

  items.forEach((item) => {
    const itemGrades = item.dataset.grades.split(',') || [];
    const itemTypes = item.dataset.type || '';

    const hasGrade =
      grade === null || grade === ''
        ? true
        : itemGrades.includes(String(grade));

    const hasType =
      type === null || type === '' ? true : itemTypes.includes(String(type));

    item.classList.toggle('hidden', !(hasGrade && hasType));
  });
}

function updateSelectsValues(
  grade = null,
  type = null,
  gradeSelect = null,
  typeSelect = null
) {
  if (grade && gradeSelect) {
    gradeSelect.value = grade;
  }
  if (type) {
    typeSelect.value = type;
  }
}

function getFiltersFromUrl() {
  const params = new URLSearchParams(window.location.search);

  return {
    grade: params.get('grade') || '',
    type: params.get('program_type') || '',
  };
}
